import React, { FC } from 'react';
import DiscountedPrice from './DiscountedPrice';
import RegularPrice from './RegularPrice';
import styles from './ProductPrice.module.scss';
import PricesSize from './types';

interface OwnProps {
  hasDiscount?: boolean;
  theme?: string;
  initialPrice?: number;
  initialPriceFormatted?: string;
  finalPrice?: number;
  finalPriceFormatted?: string;
  remark?: string;
  size?: PricesSize;
  discountedPriceFirst?: boolean;
  isPlusDiscountActive?: boolean;
}

const PriceComponent: FC<OwnProps> = ({
  finalPrice,
  finalPriceFormatted,
  hasDiscount,
  initialPrice,
  initialPriceFormatted,
  discountedPriceFirst,
  theme,
  remark,
  size,
  isPlusDiscountActive,
}) => {
  return (
    <div className={styles.pricesContainer}>
      {!discountedPriceFirst && (
        <RegularPrice
          formattedPrice={initialPriceFormatted}
          unformattedPrice={initialPrice}
          hasDiscount={hasDiscount}
          remark={remark}
          size={size}
          theme={theme}
          isPlusDiscountActive={isPlusDiscountActive}
        />
      )}
      {hasDiscount && (
        <DiscountedPrice
          formattedPrice={finalPriceFormatted}
          unformattedPrice={finalPrice}
          theme={theme}
          remark={remark}
          size={size}
          isPlusDiscountActive={isPlusDiscountActive}
        />
      )}
      {discountedPriceFirst && (
        <RegularPrice
          formattedPrice={initialPriceFormatted}
          unformattedPrice={initialPrice}
          hasDiscount={hasDiscount}
          remark={remark}
          size={size}
          theme={theme}
          isPlusDiscountActive={isPlusDiscountActive}
        />
      )}
    </div>
  );
};

export default PriceComponent;
